/**
 * Convert a listing's pricing to the marked up retail version.
 *
 * @param pricing The initial pricing of the item
 * @param markup The markup percent as a number (i.e. 15 = +15%)
 */
export function calculateMarkedUpPricing(pricing, markup) {
    // This function shouldn't be called anywhere where pricing is already baked,
    // but if it is we return the right value
    if (pricing.hasMarkupBaked)
        return pricing;
    const scheme = determinePricingScheme(pricing);
    if (scheme === "minor-major") {
        // Ugly -- early on we didn't include the stems per bunch in pricing.
        // We retrieve it this way but this is kind of gross
        // We need this value to ensure the marked up major unit price is an integer
        // multiple of the marked up minor unit price.
        const quantity = Math.round(pricing.price / pricing.pricePerStem);
        // Minor unit case
        return Object.assign(Object.assign({}, pricing), { price: applyMarkupAndRound(pricing.pricePerStem, markup) * quantity, pricePerStem: applyMarkupAndRound(pricing.pricePerStem, markup), hasMarkupBaked: true });
    }
    else if (scheme === "major-minor") {
        // Ugly -- early on we didn't include the stems per bunch in pricing.
        // We retrieve it this way but this is kind of gross
        // We need this value to ensure the marked up major unit price is an integer
        // multiple of the marked up minor unit price.
        const quantity = Math.round(pricing.price / pricing.pricePerStem);
        return Object.assign(Object.assign({}, pricing), { price: applyMarkupAndRound(pricing.price, markup), pricePerStem: Math.ceil(applyMarkupAndRound(pricing.price, markup) / quantity), hasMarkupBaked: true });
    }
    else {
        return Object.assign(Object.assign({}, pricing), { price: applyMarkupAndRound(pricing.price, markup), hasMarkupBaked: true });
    }
}
/**
 * Markup a value by a percent and round it. Used to deal with retail customers
 * and prices in cents (round up to the next nickel).
 *
 * @param value The value to round
 * @param markup The markup *increase*, as a number (i.e. 15 = +15%)
 * @param roundingInterval The interval to round to (defaults to 5)
 */
export function applyMarkupAndRound(value, markup, roundingInterval = 5) {
    if (markup === 0)
        return value;
    return Math.ceil((value * (1 + markup / 100)) / roundingInterval) * roundingInterval;
}
/**
 * There are three pricing schemes in the spec:
 *
 * "major" - Simple, one unit one price
 * "major-minor" - Sold / priced by major units but minor units are available (CSAs)
 * "minor-major"- Sold / priced by minor units but minor units are available (cut flowers)
 *
 * @param pricing The pricing object to determine
 */
export const determinePricingScheme = (pricing) => {
    const res = pricing.pricePerStem === undefined
        ? "major"
        : pricing.prioritizeMajorUnit
            ? "major-minor"
            : "minor-major";
    return res;
};
//# sourceMappingURL=pricing.js.map